/* reye-sc1-tslider.js: swipe slider for the testimonials under Add to cart */
(function () {
  if (window.reyeSc1Tslider) return;

  function setup(slider) {
    if (slider.getAttribute('data-ready')) return;
    slider.setAttribute('data-ready', '1');
    var track = slider.querySelector('[data-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var dots = Array.prototype.slice.call(slider.querySelectorAll('[data-dots] button'));
    var prev = slider.querySelector('.reye-sc1-tslider__arrow--prev');
    var next = slider.querySelector('.reye-sc1-tslider__arrow--next');
    var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var current = 0;

    function goTo(i, instant) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      var s = slides[i];
      track.scrollTo({ left: s.offsetLeft - (track.clientWidth - s.offsetWidth) / 2, behavior: (instant || calm) ? 'auto' : 'smooth' });
    }
    function update() {
      var mid = track.scrollLeft + track.clientWidth / 2, best = 0, bestDist = Infinity;
      slides.forEach(function (s, i) {
        var d = Math.abs(s.offsetLeft + s.offsetWidth / 2 - mid);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      current = best;
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === best); });
      if (prev) prev.disabled = best === 0;
      if (next) next.disabled = best === slides.length - 1;
    }

    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    dots.forEach(function (d, i) { d.addEventListener('click', function () { goTo(i); }); });
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
    });
    slider.reyeGoTo = goTo;
    update();
  }

  function boot(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('[data-reye-sc1-tslider]'), setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();

  /* theme editor: set up sections that are re-rendered, and jump to a block when it is selected */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var slider = e.target.closest ? e.target.closest('[data-reye-sc1-tslider]') : null;
    if (!slider || !slider.reyeGoTo) return;
    var track = slider.querySelector('[data-track]');
    var i = Array.prototype.indexOf.call(track.children, e.target);
    if (i > -1) slider.reyeGoTo(i, true);
  });

  window.reyeSc1Tslider = { boot: boot };
})();
